export default __webpack_public_path__ + "static/media/under-trunck.4d8a5236.png";